import { combineReducers } from 'redux';
// import {LOCATION_CHANGE} from 'react-router-redux';
import { UPDATE_CONTENT } from '../actions/content';
import {
    GET_FUTURE_PAGE,
    RESET_PAGINATION,
    SET_CURRENT_PAGE,
} from '../actions/pagination';

/*
* @event, @profile, @article all share the following shape:
*    Array of objects where each object corresponds to
*    the indexed page.
*
*    event: {
*        0: {
*            ids: [1,2,3,4,5],
*            continuation: 'token',
*            pageSize: 10,
*            objectCount: 3000
             pageNumber: 1
*        }
*    }
*/
const event = (
    state = {},
    { type, payload }: { type: string; payload?: any },
) => {
    let nextState = state;

    if (type === UPDATE_CONTENT && payload.pagination.event) {
        nextState = {
            ...nextState,
            ...payload.pagination.event,
        };
    }

    if (type === RESET_PAGINATION) {
        nextState = {};
    }

    return nextState;
};

const profile = (
    state = {},
    { type, payload }: { type: string; payload?: any },
) => {
    let nextState = state;

    if (type === UPDATE_CONTENT && payload.pagination.profile) {
        nextState = {
            ...nextState,
            ...payload.pagination.profile,
        };
    }

    if (type === RESET_PAGINATION) {
        nextState = {};
    }

    return nextState;
};

const article = (
    state = {},
    { type, payload }: { type: string; payload?: any },
) => {
    let nextState = state;

    if (type === UPDATE_CONTENT && payload.pagination.article) {
        nextState = {
            ...nextState,
            ...payload.pagination.article,
        };
    }

    if (type === RESET_PAGINATION) {
        nextState = {};
    }

    return nextState;
};

const currentPage = (
    state = 0,
    { type, payload }: { type: string; payload?: any },
) => {
    let nextState = state;

    if (type === SET_CURRENT_PAGE) {
        nextState = payload;
    }

    // if (type === LOCATION_CHANGE && payload.action === 'POP') {
    //     const {
    //         query: {
    //             [EVENT_PAGE_PARAM]: eventPage,
    //         },
    //     } = payload;

    //     if (eventPage > 0) {
    //         nextState = eventPage - 1;
    //     } else if (!eventPage) {
    //         nextState = 0;
    //     }
    // }

    if (type === RESET_PAGINATION) {
        nextState = 0;
    }

    return nextState;
};

const loading = (state = false, { type }: { type: string }) => {
    let nextState = state;

    if (type === SET_CURRENT_PAGE) {
        nextState = false;
    }

    if (type === UPDATE_CONTENT) {
        nextState = false;
    }

    if (type === GET_FUTURE_PAGE) {
        nextState = true;
    }

    if (type === RESET_PAGINATION) {
        nextState = true;
    }

    return nextState;
};

export default combineReducers({
    event,
    profile,
    article,
    currentPage,
    loading,
});
